import type { ReactElement } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/shared/cn';

const EDGE_TOGGLE_POSITION_TRANSITION =
  'transition-[left] duration-300 ease-[cubic-bezier(0.32,0.72,0,1)]';

export type SidebarEdgeToggleProps = {
  expanded: boolean;
  onToggle: () => void;
  expandLabel: string;
  collapseLabel: string;
  side?: 'left' | 'right';
  offsetPx?: number;
};

export function SidebarEdgeToggle({
  expanded,
  onToggle,
  expandLabel,
  collapseLabel,
  side = 'left',
  offsetPx = 0,
}: SidebarEdgeToggleProps): ReactElement {
  const label = expanded ? collapseLabel : expandLabel;
  const Icon = expanded ? ChevronLeft : ChevronRight;

  return (
    <button
      type="button"
      onClick={onToggle}
      title={label}
      aria-label={label}
      className={cn(
        'absolute top-1/2 z-30 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full',
        side === 'left' ? '-translate-x-1/2' : 'right-0 translate-x-1/2',
        'border border-black/[0.06] bg-[var(--background)] shadow-sm dark:border-white/[0.08] dark:bg-zinc-900',
        side === 'left' && EDGE_TOGGLE_POSITION_TRANSITION,
        'text-zinc-500 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100',
        'hover:bg-white dark:hover:bg-zinc-800',
      )}
      style={side === 'left' ? { left: `${offsetPx}px` } : undefined}
    >
      <Icon className="h-3.5 w-3.5 flex-shrink-0" strokeWidth={1.6} />
    </button>
  );
}
